import { useEffect, useState } from 'react'
import { useScrollReveal } from '@/hooks/useScrollReveal'
import { fetchCmsPage, type CmsPage } from '@/api/cms'
import { useBranding } from '@/branding/BrandingProvider'
import { Seo } from '@/seo/Seo'
import { homeJsonLd } from '@/seo/structuredData'
import { trackEvent } from '@/tracking/track'
import { LandingNavbar } from './sections/LandingNavbar'
import { HeroSection } from './sections/HeroSection'
import { FourPillarsSection } from './sections/FourPillarsSection'
import { EdgeAdvantageSection } from './sections/EdgeAdvantageSection'
import { AdinaAISection } from './sections/AdinaAISection'
import { PricingSection } from './sections/PricingSection'
import { FooterSection } from './sections/FooterSection'

export function LandingPage() {
  const [_cmsPage, setCmsPage] = useState<CmsPage | null>(null)
  const { siteName, tagline } = useBranding()
  useScrollReveal()

  useEffect(() => {
    trackEvent('view_content', { content_name: 'storefront-home', content_type: 'landing' })
    fetchCmsPage('storefront-home').then((page) => {
      if (page) setCmsPage(page)
    })
  }, [])

  // CMS blocks could override defaultContent in the future.
  // For now, sections fall back to static defaults from defaultContent.ts

  return (
    <>
      <Seo
        title={
          siteName.toLowerCase().includes('zenzers')
            ? 'Zenzers — Geriatric Remote Monitoring & Fall Detection'
            : `${siteName} — ${tagline}`
        }
        description={
          siteName.toLowerCase().includes('zenzers')
            ? 'Geriatric remote monitoring by Zenzers: continuous vitals, AI fall detection, and instant caregiver alerts — privacy-first, processed on the edge.'
            : `${siteName}: ${tagline}.`
        }
        path="/"
        jsonLd={homeJsonLd}
      />
      <LandingNavbar />
      <main className="pt-20">
        <HeroSection />
        <FourPillarsSection />
        <EdgeAdvantageSection />
        <AdinaAISection />
        <PricingSection />
      </main>
      <FooterSection />
    </>
  )
}
